export default "__VITE_ASSET__Cqs3va3Z__"